
<i class="material-icons" v-text="selector"></i>
